import * as React from "react";
import Button from "./Button";
import Header from "./Header";
import MessengerFlexContainer from "./MessengerFlexContainer";

interface Props {
  message: string;
  isPopout: boolean;
  onCollapse: () => void;
  onClickRetry: () => void;
}

export default function ErrorView(props: Props) {
  return (
    <MessengerFlexContainer>
      <Header isPopout={props.isPopout} onCollapse={props.onCollapse} />
      <div className="velaro-error-view-container">
        <div className="error-view-message">
          We're sorry. An unexpected problem has occured. Please click the
          button to try live chat again.
        </div>
        <div className="error-view-problem">{props.message}</div>
        <div className="error-view-button">
          <Button variant="primary" onClick={props.onClickRetry}>
            Try again
          </Button>
        </div>
      </div>
    </MessengerFlexContainer>
  );
}
